/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/GameModes/TriPeaksGameMode',['Solitaire/GameModes/GameModeBase',
        'Solitaire/GameModes/IGameMode',
        'Solitaire/Solitaire',
        'Solitaire/SolitaireGameMode',
        'SolitaireShared/TriPeaksTemplate/TriPeaksWindowsTemplate',
        'SolitaireShared/CardLogic/Supply',
        'Solitaire/GameResult',
        'Solitaire/GameState',
        'Solitaire/SolitaireStatistics'],
function (GameModeBase, IGameMode, SolitaireGame, SolitaireGameMode, TriPeaksWindowsTemplate, Supply, GameResult, GameState, SolitaireStatistics) {
    "use strict";

    var TriPeaksGameMode = function () {
        this.initTriPeaksGameMode();
    };

    TriPeaksGameMode.constructor = TriPeaksGameMode;
    TriPeaksGameMode.prototype = Object.create(GameModeBase.prototype);
    IGameMode.call(TriPeaksGameMode.prototype);

    TriPeaksGameMode.prototype.initTriPeaksGameMode = function () {
        this.Name = SolitaireGameMode.TriPeaks;
        this.WaitForAnimationOnHint = false;
    };

    Object.defineProperty(TriPeaksGameMode.prototype, "TimerOption", {
        get: function () {
            if (GameState.CurrentGame.Authority.IsChallenge) {
                return GameState.CurrentGame.Authority.TimerEnabled ? IGameMode.TimerSettings.CountDown : IGameMode.TimerSettings.Off;
            }
            return IGameMode.TimerSettings.Off;
        }
    });

    TriPeaksGameMode.prototype.OnMoveCardButton = function () {
    };

    
    TriPeaksGameMode.prototype.IsUpdateDealButtonsVisible = function ()
    {
        var isStartingDC = GameState.CurrentGame.Authority.CardSupply.IsWaitingForAds || !GameState.CurrentGame.Authority.CardSupply.IsGamePageLoaded;
        var canToDeal = (GameState.CurrentGame.Authority.CardSupply.GetPile("Stock").Count == 0);
        return !isStartingDC && canToDeal;
    };   

    TriPeaksGameMode.prototype.IsUpdateDrawButtonVisible = function ()
    {
        return false;
    };

    TriPeaksGameMode.prototype.ConfigureSolitairePage = function (page)
    {
        Supply.UseCumulativeScoring = false;
    };

    TriPeaksGameMode.prototype.CreateTemplate = function ()
    {
        return new TriPeaksWindowsTemplate();
    };

    TriPeaksGameMode.prototype.GetCheatMoves = function ()
    {
        return "G TRIPEAKS O SHUFFLE_0 23300404821998148255264241710013489742524053918641307983027393488047237440914352187968148924726293127043466634092752002595262028194245227115087614301864275366 O SHUFFLE_1 770114002330040482199814825526424171001348974252405391864130798302739348804723744091435218796814892472629312704346663409275200259526202819424522711508761430 O SHUFFLE_2 285370938377011400233004048219981482552642417100134897425240539186413079830273934880472374409143521879681489247262931270434666340927520025952620281942452271 O NUM_SHUFFLES_STORED 3 O SHUFFLE_3 2642417100134897425240539186413079830273934880472374409143521879681489247262931270434666340927520025952620281942452271150876143018642753663396205882181990241 D 63882222104584319680929264235058511924883227801076008702301864275366 M 45 3 1 [1] M 2 3 1 [2] M 41 3 1 [2] B M 43 3 1 M 22 23 1 M 24 25 1 E [3] M 55 3 1 [3] B M 53 3 1 M 34 35 1 E [3] M 59 3 1 [5] M 23 3 1 [5] B M 57 3 1 M 36 37 1 M 38 39 1 E [6] B M 25 3 1 M 10 11 1 E [7] M 2 3 1 [8] B M 51 3 1 M 32 33 1 E [9] M 37 3 1 [9] B M 49 3 1 M 30 31 1 E [9] M 33 3 1 [11] M 11 3 1 [11] B M 31 3 1 M 16 17 1 E [12] M 17 3 1 [13] M 2 3 1 [14] M 2 3 1 [14] B M 35 3 1 M 18 19 1 E [15] B M 47 3 1 M 26 27 1 M 28 29 1 E [15] B M 39 3 1 M 20 21 1 E [16] B M 29 3 1 M 14 15 1 E [16] M 21 3 1 [17] M 2 3 1 [18] M 2 3 1 [19] B M 15 3 1 M 6 7 1 E [20] B M 19 3 1 M 8 9 1 E [21] M 7 3 1 [21] M 2 3 1 [22] M 9 3 1 [23] M 2 3 1 [24] B M 27 3 1 M 12 13 1 E [25] M 2 3 1 [26] B M 13 3 1 M 4 5 1 E [29] M 2 3 1 [30] M 2 3 1 [31] M 2 3 1 [31] M 2 3 1 [32] M 2 3 1 [32] M 2 3 1 [33] M 2 3 1 [34] M 2 3 1 [34] M 2 3 1 [35] M 2 3 1 [35] N ";
    };

    TriPeaksGameMode.prototype.HelpDataSource = function ()
    {
        return null; // TODO not supported?
        //return SimpleIoc.Default.GetInstance<MvvmStructure.Model.TriPeaksHelpDataSource>();
    };

    TriPeaksGameMode.prototype.ButtonsPostion = function (invertAxis)
    {
        invertAxis = !!invertAxis;
        throw "TODO";
        // TODO supported?
        /*
        var result = new Dictionary<GameButtons, Vector2>();
        var stockPosition = GetPilePostion("Stock");
        var wastePosition = GetPilePostion("Waste");

        Vector2 position = Vector2.Zero;
        if (!invertAxis)
        {
            position = new Vector2((stockPosition.X + wastePosition.X) * 0.5f, stockPosition.Y);
            result.Add(GameButtons.Deal, position);
        }
        else
        {
            position = new Vector2(stockPosition.X, (stockPosition.Y + wastePosition.Y) * 0.5f);
            position.Y += 4;
            result.Add(GameButtons.Deal, position);
        }

        return result;
        */
    };

    TriPeaksGameMode.prototype.GetGameEnd = function ()
    {
        throw "TODO";
        // TODO 
        /*
        var model = new GameEndModel
        {
            LockIconSourcePath = "Assets/ui/icons/update.png",
        };

        model.AddStatValue("ScoreText", LocalizationManager.GetString("YouScoredColon_Title/Text"), GameEndTileTemplates.Highlighted);
        model.AddStatValue("HighScore", LocalizationManager.GetString("HighScore_Title/Text"), GameEndTileTemplates.Highlighted);
        model.AddStatValue("GamesPlayed", LocalizationManager.GetString("GamesPlayed_Title/Text"));
        model.AddStatValue("BoardsCleared", LocalizationManager.GetString("BoardsCleared_Title/Text"));
        //model.AddStatValue("AverageBoards", LocalizationManager.GetString("BoardsCleared_Title/Text"));
        model.AddStatValue("CardsChained", LocalizationManager.GetString("CardsChained_Title/Text"));
        model.UpdateStatistics = UpdateStatistics;
        SetDefaults(model);

        return model;
        */
    };

    TriPeaksGameMode.prototype.SetShare = function (args)
    {
        // TODO - supported
        /*
        var description = new StringBuilder();
        var message = new StringBuilder();
        string gameTitle = SetDefaultShareMessage(description, message, Name.ToString());
        message.Replace("%GAME_TITLE%", gameTitle).Replace("%SCORE%", GameState.CurrentGame.Authority.BoardsCompleted().ToString());
        ShareManager.SetShareMessage(args, gameTitle, description, message);
        */
    };

    TriPeaksGameMode.GetStatKeyStatic = function ()
    {
        return new SolitaireStatistics.StatKey
        (
            GameState.CurrentGame.ActiveMode.Name,
            SolitaireGameMode.getModeById(GameState.CurrentGame.ActiveMode.Name).toUpperCase()
        );

    };   

    TriPeaksGameMode.prototype.GetStatKey = function ()
    {
        return TriPeaksGameMode.GetStatKeyStatic();
    };

    TriPeaksGameMode.prototype.UpdateStatistics = function (model)
    {

        //if (GameState.CurrentGame.ActiveMode.Name == SolitaireGameMode.Unknown) return;

        var statkey = TriPeaksGameMode.GetStatKeyStatic();

        //if (GameState.CurrentGame.GameResult == GameResult.Win)
        if(GameState.CurrentGame.Authority.BoardsCompleted() > 0)
        {
            //User Won here so update stats and save them to disk
            SolitaireStatistics.Current.UpdateGameWon(statkey);
        }
        else if (GameState.Current == GameState.GameComplete)
        {
            //User Lost here so update stats and save them to disk
            SolitaireStatistics.Current.UpdateGameLost(statkey);
        }
        //Update GameEnd Model with Latest Stats
        model["ScoreText"] =  SolitaireStatistics.Current.GetScoreFormatString(statkey);
        model["HighScore"] =  SolitaireStatistics.Current.GetHighScoreFormatString(statkey);
        model["GamesPlayed"] =  SolitaireStatistics.Current.GetGamesPlayedFormatString(statkey);
        model["BoardsCleared"] =  SolitaireStatistics.Current.GetStringFormat(GameState.CurrentGame.Authority.BoardsCompleted());
        model["PeaksCleared"] =  SolitaireStatistics.Current.GetStringFormat(GameState.CurrentGame.Authority.NumPeaksCleared);
        //model.UpdateStatValue("AverageBoards", SolitaireStatistics.Current.GetStringFormat(GameState.CurrentGame.Authority.BoardsCompleted()));
        model["LongestCardsChained"] = SolitaireStatistics.Current.GetStringFormat(GameState.CurrentGame.Authority.CardsChained);
        //model["CardsChained"] =  SolitaireStatistics.Current.GetCardsChainedFormatString(statkey);
        model["LosingStreak"] =  SolitaireStatistics.Current.GetLosingStreak(statkey);

        //UpdateLiveTile();

    };
    /*
    TODO
    private static Vector2 GetPilePostion(string key)
    {
        if (GameState.CurrentGame.SupplyView != null)
        {
            var stockPile = GameState.CurrentGame.SupplyView.CardSupply.GetPile(key);
            PileView stockPileView = GameState.CurrentGame.SupplyView.GetPileView(stockPile);
            var position = stockPileView.GetScreenPosition();
            return position;
        }
        return Vector2.Zero;
    }
   */
    TriPeaksGameMode.prototype.UpdateLeaderBoard = function ()
    {
        // unsuported
        /*
        var current = GameState.CurrentGame;
        var stats = SolitaireStatistics.Current;
        if ( App.CurrentApp.GameNetClient.Settings.XblConnected)
        {
            Arkadium.SharedEntities.ResultObject<string> result; //string result;

            // high score
            result = await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore((int)stats.GetHighScore(GetStatKeyStatic()), 13, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Max);

            // boards cleared
            result = await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore((int)stats.GetBoards(GetStatKeyStatic()), 14, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Max);
            result = await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore((int)stats.GetHighestBoards(GetStatKeyStatic()), 15, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Max);
        }
        */
    };

    return TriPeaksGameMode;
});
